import { defineWe0App } from "../we0-runtime/define-app";
import "./app/global.css";
import "./app/globals.css";
import { InsightsRoute, routes } from "./routes";
import { AuthDialog } from "./components/auth/auth-dialog";
import { AppErrorBoundary } from "./components/monitoring/app-error-boundary";
import { Toaster } from "./components/ui/sonner";
import { appI18n } from "./i18n";
import { siteConfig } from "./lib/site-config";

export default defineWe0App({
  routes,
  i18n: appI18n,
  ssr: {
    documentTitle: "增长深度 GrowDeep｜企业品牌增长与产品出海",
    metaDescription: siteConfig.brand.description,
    favicon: "/favicon.ico",
    pages: [{ path: "/insights", page: InsightsRoute }],
  },
  slots: {
    AuthDialog,
    ErrorBoundary: AppErrorBoundary,
    Toaster,
  },
});
